export default __webpack_public_path__ + "static/media/resize_black_24dp.e78c4421.svg";